"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iUpdateCustomer = exports._iUpdateCustomer = exports.iCreateCustomer = exports.iCustomerMembers = exports.iContractFile = exports.iExtendedCustomer = exports.iCustomer = exports.iYtjCompany = void 0;
const t = require("io-ts");
const user_1 = require("./user");
const AddressDetails = require("./addressDetails");
const Feature = require("./feature");
const _iYtjCompany = t.intersection([
    t.interface({
        name: t.string,
        businessId: t.string
    }),
    t.partial({
        addressDetails: AddressDetails.iAddressDetailsPartial
    })
]);
exports.iYtjCompany = t.clean(_iYtjCompany);
const _iCustomer = t.intersection([
    exports.iYtjCompany,
    t.interface({
        id: t.number,
        uuid: t.string,
        type: t.literal('CUSTOMER')
    }),
    t.partial({
        projects: t.number,
        employees: t.number,
        federated: t.boolean,
        reliablePartner: t.boolean,
        contractorsReport: t.string,
        ralaCompetence: t.string,
        reliablePartnerCompanyName: t.union([t.null, t.string]),
        domains: t.array(t.string)
    })
]);
exports.iCustomer = t.clean(_iCustomer);
//#region Admin Customer
const _iExtendedCustomer = t.intersection([
    exports.iCustomer,
    t.interface({
        client: t.boolean,
        hasLogo: t.boolean,
        salesRepresentative: t.union([t.null, user_1.iAuthor]),
        features: t.union([t.null, t.array(Feature.iFeature)])
    })
]);
exports.iExtendedCustomer = t.clean(_iExtendedCustomer);
const _iContractFile = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        name: t.string,
        size: t.number,
        createdAt: t.string
    }),
    t.partial({
        key: t.string
    })
]);
exports.iContractFile = t.clean(_iContractFile);
const _iCustomerMembers = t.interface({
    level: t.string,
    members: t.array(user_1.iUser)
});
exports.iCustomerMembers = t.clean(_iCustomerMembers);
const iRequired = t.interface({
    name: t.string,
    hasBusinessId: t.boolean,
    businessId: t.string,
    street: t.string,
    postalCode: t.string,
    city: t.string,
    state: t.string,
    country: t.string
});
const iExtended = t.interface({
    salesRepresentative: t.union([t.null, t.number]),
    client: t.boolean,
    features: t.union([t.array(Feature.iFeature), t.null])
});
const iCreateNormal = t.intersection([
    t.interface({ type: t.literal('NORMAL') }),
    iRequired
]);
const iCreateExtended = t.intersection([
    t.interface({ type: t.literal('ADMIN') }),
    iRequired,
    iExtended
]);
const _iCreateCustomer = t.union([iCreateNormal, iCreateExtended]);
exports.iCreateCustomer = t.clean(_iCreateCustomer);
exports._iUpdateCustomer = t.intersection([
    t.interface({ uuid: t.string }),
    iRequired,
    iExtended
]);
exports.iUpdateCustomer = t.clean(exports._iUpdateCustomer);
//#endregion
//# sourceMappingURL=customer.js.map